var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Invoice',{attrs:{"deliveryData":_vm.deliveryData}}),_c('Details',{attrs:{"deliveryData":_vm.deliveryData}}),_c('Items',{attrs:{"deliveryData":_vm.deliveryData}}),_c('Total',{attrs:{"deliveryData":_vm.deliveryData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }